import axiosInstance from './axiosInstance';

export const getListingImageUploadUrl = async (fileInfo) => {
    const response = await axiosInstance.post(`/users/me/listing-images/uploads`, fileInfo);
    return response.data;
}; 

export const getAvatarUploadUrl = async (fileInfo) => {
    const response = await axiosInstance.post(`/users/me/avatars/uploads`, fileInfo);
    return response.data;
}; 
